import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { AuthState, LoginCredentials, UserCredential } from "./auth-state";

const initialState: AuthState = {
    userCredentials: null,
    pendingEmail: null,
    justLoggedOut: false,
    loginCredential: { email: '', password: '' },
    isInitialized: false,
};

const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<UserCredential>) => {
            state.userCredentials = action.payload;
            state.justLoggedOut = false;
        },
        clearCredentials: (state) => {
            state.userCredentials = null;
            state.justLoggedOut = true;
        },
        
        setPendingEmail: (state, action: PayloadAction<string>) => {
            state.pendingEmail = action.payload;
        },
        clearPendingEmail: (state) => {
            state.pendingEmail = null;
        },

        setLoginCredential: (state, action: PayloadAction<LoginCredentials>) => {
            state.loginCredential = action.payload;
        },
        clearLoginCredential: (state) => {
            state.loginCredential = { email: '', password: '' }; 
        },

        // resetLogoutFlag: (state) => {
        //     state.justLoggedOut = false;
        // },
        setAuthInitialized: (state, action: PayloadAction<boolean>) => {
            state.isInitialized = action.payload;
        },
        clearAllAuth: () => initialState,
    },
});

export const {
    setCredentials,
    clearCredentials,
    setPendingEmail,
    clearPendingEmail,
    // resetLogoutFlag,
    setLoginCredential,
    clearLoginCredential,
    setAuthInitialized,
    clearAllAuth
} = authSlice.actions;

export default authSlice.reducer;

export const selectCredentials = (state: RootState) => state.authSlice.userCredentials;
export const selectUserCredentials = (state: RootState) => state.authSlice.userCredentials?.user;
export const selectAccessToken = (state: RootState) => state.authSlice.userCredentials?.accessToken;
export const selectRefreshToken = (state: RootState) => state.authSlice.userCredentials?.refreshToken;
export const selectUserId = (state: RootState) => state.authSlice.userCredentials?.user.user_id;
export const selectUserData = (state: RootState) => state.authSlice.userCredentials?.user;
export const selectUserDepartmentCode = (state: RootState) => state.authSlice.userCredentials?.user.departmentCode;
export const selectUserRole = (state: RootState) => state.authSlice.userCredentials?.user.roleName;
export const selectUserEmail = (state: RootState) => state.authSlice.userCredentials?.user?.email;
export const selectPendingEmail = (state: RootState) => state.authSlice.pendingEmail;
export const selectJustLoggedOut = (state: RootState) => state.authSlice.justLoggedOut;
export const selectLoginCredential = (state: RootState) => state.authSlice.loginCredential;
export const selectMustChangePassword = (state: RootState) => state.authSlice.userCredentials?.user.mustChangePassword;
export const selectAuthInitialized = (state: RootState) => state.authSlice.isInitialized;